var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinished({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-finished",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Sun",
    d: "M9,2a.656.656,0,0,1,.656.656V3.81a.656.656,0,0,1-1.312,0V2.656A.656.656,0,0,1,9,2ZM9,6.773A2.227,2.227,0,1,0,11.227,9,2.227,2.227,0,0,0,9,6.773ZM5.46,9A3.54,3.54,0,1,1,9,12.54,3.54,3.54,0,0,1,5.46,9Zm4.2,5.19a.656.656,0,0,0-1.312,0v1.153a.656.656,0,0,0,1.313,0ZM4.049,4.049a.656.656,0,0,1,.928,0l.819.819a.656.656,0,0,1-.928.928l-.819-.819A.656.656,0,0,1,4.049,4.049ZM13.132,12.2a.656.656,0,0,0-.928.928l.819.819a.656.656,0,0,0,.928-.928ZM2,9a.656.656,0,0,1,.656-.656H3.81a.656.656,0,0,1,0,1.313H2.656A.656.656,0,0,1,2,9Zm12.19-.656a.656.656,0,0,0,0,1.313h1.153a.656.656,0,0,0,0-1.312ZM5.8,12.2a.656.656,0,0,1,0,.928l-.819.819a.656.656,0,1,1-.928-.928l.819-.819A.656.656,0,0,1,5.8,12.2Zm8.155-7.227a.656.656,0,0,0-.928-.928l-.819.819a.656.656,0,0,0,.928.928Z",
    transform: "translate(-2 -2)",
    fill: "#333",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinished);
export default __webpack_public_path__ + "static/media/finished.9a2822382a3fb115ef06589d314429f4.svg";
export { ForwardRef as ReactComponent };